import { useNavigate, useParams } from 'react-router-dom';

import { useMessagingSocket } from '@/hooks/useMessagingSocket';

import { ConversationList } from './components/ConversationList';
import { MessageThread } from './components/MessageThread';

export const MessagingPage = () => {
  useMessagingSocket();
  const { conversationId } = useParams<{ conversationId?: string }>();
  const navigate = useNavigate();

  const handleSelectConversation = (id: string) => {
    navigate(`/messaging/${id}`);
  };

  return (
    <div className="flex h-[calc(100vh-4rem)] overflow-hidden rounded-lg border">
      {/* Left panel — conversation list */}
      <div className="w-80 shrink-0 border-r">
        <ConversationList selectedId={conversationId} onSelect={handleSelectConversation} />
      </div>

      {/* Right panel — message thread */}
      <div className="flex-1">
        <MessageThread conversationId={conversationId} />
      </div>
    </div>
  );
};
